export const REQUEST_TRAIL_FORM_TYPEFORM_ID = 'o0RlOWaf';

export const NOTIFICATION_POLLING_DELAY = 2 * 60 * 1000;

export const MENU_EXPANDED_WIDTH = 290;
export const MENU_COLLAPSED_WIDTH = 80;
